module.exports = __webpack_public_path__ + "static/img/swipe-6.db91166.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phoneHomePage/swipe-6.png
// module id = Xp9R
// module chunks = 0